import React from "react";
import Chip from "@material-ui/core/Chip";
import styled from "styled-components";
import produce from "immer";
import Wrapper from "../atoms/Wrapper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Link from "../atoms/Link";
import { useSelector } from "react-redux";
import { Cancel } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";

const PoppedTextWrapper = styled.div`
  padding: 0.8rem 1.4rem;
`;

const PoppedText = styled.div`
  padding: 0.5rem 0;
`;

const StyledWrapper = styled(Wrapper)`
  width: 100%;
  justify-content: flex-start;
  color: ${props => props.theme.colors.black100};
  box-sizing: border-box;
  overflow-x: auto;
  padding: 0.4rem 0;
`;
const Tag = styled.div`
  padding: 0.1rem 0.35rem 0.1rem 0;
`;
const StyledForm = styled.form`
  width: 100%;
`;
const StyledCancel = styled(Cancel)`
  color: ${props => props.theme.colors.gray};
`;

const OuterWrapper = styled(Wrapper)`
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 450px) {
    width: 100%;
  }
`;

const TagsLinkWrapper = styled(Wrapper)`
  margin-left: -0.2rem;
`;

const Tags = props => {
  const [edit_mode, set_edit_mode] = React.useState(false);
  const [edit_state, set_edit_state] = React.useState(
    props.tags.map(tag => tag.name)
  );
  const is_signed_in = useSelector(
    state => state.reduxTokenAuth.currentUser.isSignedIn
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const addTag = e => {
    e.preventDefault();
    set_edit_state(prev => ["", ...prev]);
  };
  const turn_on_edit_mode = e => {
    if (is_signed_in) {
      e.preventDefault();
      set_edit_mode(true);
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const turn_off_edit_mode = e => {
    e.preventDefault();
    set_edit_mode(false);
  };
  const saveTags = e => {
    e.preventDefault();
    set_edit_mode(false);
    props.saveTags && props.saveTags(edit_state);
  };
  const handleRemoveTag = idx => e => {
    e.stopPropagation();
    e.preventDefault();

    set_edit_state(
      produce(edit_state, draft => {
        draft.splice(idx, 1);
        return draft;
      })
    );
  };
  const handleTagChange = idx => e => {
    set_edit_state(
      produce(edit_state, draft => {
        draft[idx] = e.target.value;
        return draft;
      })
    );
  };
  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
      e.target.reportValidity();
    }
    set_edit_mode(false);
    props.saveTags && props.saveTags(edit_state);
  };
  const update_tags_state = useSelector(state => state.tag.state);
  const [fake_enabled, set_fake_enabled] = React.useState(false);
  const [fake_tags, set_fake_tags] = React.useState([]);
  React.useEffect(() => {
    if (update_tags_state === "success") {
      set_fake_enabled(true);
      set_fake_tags(
        edit_state
          .filter(
            tag =>
              typeof tag === "string" && tag.replace(/( |　)/g, "").length > 0
          )
          .map(tag => ({ name: tag }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update_tags_state]);

  React.useEffect(() => {
    set_edit_state(props.tags ? props.tags.map(tag => tag.name) : []);
  }, [props.tags]);

  const is_popped = Boolean(anchorEl);
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  if (edit_mode) {
    if (update_tags_state === "request") {
      return <CircularProgress />;
    }

    return (
      <OuterWrapper>
        <StyledForm onSubmit={handleSubmit}>
          <StyledWrapper
            style={
              props.right
                ? { justifyContent: "flex-end" }
                : { justifyContent: "flex-start" }
            }
          >
            <Tooltip title="保存">
              <Tag>
                <Chip
                  label={"保存"}
                  onClick={saveTags}
                  color="primary"
                  size={props.small ? "small" : "medium"}
                />
              </Tag>
            </Tooltip>
            <Tooltip title="キャンセル">
              <Tag>
                <Chip
                  label={"キャンセル"}
                  onClick={turn_off_edit_mode}
                  color="secondary"
                  variant="outlined"
                  size={props.small ? "small" : "medium"}
                />
              </Tag>
            </Tooltip>
            <Tooltip title="タグ追加">
              <Tag>
                <Chip
                  label={"追加"}
                  onClick={addTag}
                  size={props.small ? "small" : "medium"}
                />
              </Tag>
            </Tooltip>
            {edit_state &&
              edit_state.map((tag, idx) => (
                <Tag key={idx}>
                  <Chip
                    onClick={e => {
                      e.preventDefault();
                    }}
                    component={TextField}
                    label={tag}
                    size={props.small ? "small" : "medium"}
                    inputProps={{ maxLength: 24 }}
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={handleRemoveTag(idx)}>
                          <StyledCancel />
                        </IconButton>
                      ),

                      onChange: handleTagChange(idx),
                      value: tag,
                      style: {
                        marginRight: "6px",
                        padding: "0 0  0 12px",
                        fontSize: "0.8125rem",
                        borderRadius: "16px",
                        height: "32px",
                        minWidth: "6rem"
                      }
                    }}
                  />
                </Tag>
              ))}
          </StyledWrapper>
        </StyledForm>
        <TagsLinkWrapper>
          <Link to="/tags">
            <Button color="primary">タグ一覧を見てみる</Button>
          </Link>
        </TagsLinkWrapper>
      </OuterWrapper>
    );
  }

  const tags = fake_enabled ? fake_tags : props.tags;
  return (
    <OuterWrapper>
      <StyledWrapper style={props.right ? { justifyContent: "flex-end" } : {}}>
        {props.editable && (
          <Tooltip title="タグを編集">
            <Tag>
              <Chip
                label={"タグ編集"}
                onClick={turn_on_edit_mode}
                variant="default"
                size={props.small ? "small" : "medium"}
              />
              <Popover
                id="popover"
                open={is_popped}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
              >
                <PoppedTextWrapper>
                  <PoppedText>ログインが必要です。</PoppedText>
                  <Link to="/login">
                    <Button variant="outlined" color="primary">
                      ログイン
                    </Button>
                  </Link>
                </PoppedTextWrapper>
              </Popover>
            </Tag>
          </Tooltip>
        )}
        {tags &&
          tags.map((tag, idx) => (
            <Tag key={idx}>
              <Chip
                onClick={e => {}}
                component={Link}
                to={`/search?t%5B%5D=${tag.name}${
                  props.w ? `&w=${props.w}` : ""
                }`}
                label={tag.name}
                color="primary"
                variant="outlined"
                size={props.small ? "small" : "medium"}
              />
            </Tag>
          ))}
      </StyledWrapper>
    </OuterWrapper>
  );
};

export default Tags;
